import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '@/lib/api';
import { PageHeader } from '@/components/ui-kit/PageBits';

export default function GamesPage() {
  const [games, setGames] = useState([]);
  useEffect(() => { api.get('/games').then(r => setGames(r.data)); }, []);
  return (
    <div className="p-8 max-w-6xl mx-auto">
      <PageHeader title="Base de partidas" subtitle="Explora y analiza partidas" testId="games-header"/>
      <div className="rounded-2xl bg-white border border-slate-200 overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-xs uppercase tracking-widest text-slate-500 font-bold">
            <tr>
              <th className="text-left p-3">Blancas</th>
              <th className="text-left p-3">Negras</th>
              <th className="text-left p-3">Resultado</th>
              <th className="text-left p-3">Evento</th>
              <th className="text-left p-3">Fecha</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {games.map(g => (
              <tr key={g.id} data-testid={`game-${g.id}`} className="border-t hover:bg-slate-50">
                <td className="p-3 font-semibold">{g.white_player}</td>
                <td className="p-3 font-semibold">{g.black_player}</td>
                <td className="p-3 font-mono">{g.result}</td>
                <td className="p-3 text-slate-600">{g.event}</td>
                <td className="p-3 text-slate-600">{g.date}</td>
                <td className="p-3"><Link to={`/student/games/${g.id}`} className="text-blue-600 font-semibold">Ver</Link></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
